module.exports = "/assets/data/ce888d4c847d97f6a0180a0753ce6a28-NE48.data.json";